import { useMainKeyVisualAndKeyVisuals } from "@/components/features/_hooks/use-main-kv-and-kvs";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionKeyVisual = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { mainKeyVisual, keyVisuals } = viewModel;

	return useMainKeyVisualAndKeyVisuals({
		mainKeyVisual,
		keyVisuals,
		onSetMainKeyVisual: onSetViewModel,
		onSetKeyVisuals: onSetViewModel,
	});
};
